import { MemoizedSelector, createSelector } from '@ngrx/store';
import { portfolioSmartSearchAdapter } from '@platform/portfolio/adapters/portfolio-smart-search.adapter';
import { PortfolioSmartSearchModel } from '@platform/smart-search/models/portfolio-smart-search.model';
import { AppState } from '@shared/models/app-state.model';
import { selectPropertyMortgageSelectItems } from '@shared/store/common.selectors';
import { selectCanAccessSmartSearch } from '@shared/store/company/company.selectors';
import { selectIsLoadingSmartSearchCases, selectSmartSearchCases } from '@shared/store/smart-search-cases/smart-search-cases.selectors';
import {
  selectIsLoadingSmartSearchDeals,
  selectSmartSearchDealEntities,
} from '@shared/store/smart-search-deals/smart-search-deals.selectors';
import { selectIsLoadingSmartSearches, selectSmartSearches } from '@shared/store/smart-searches/smart-searches.selectors';

export const selectIsLoadingPortfolioSmartSearch = createSelector(
  selectIsLoadingSmartSearches,
  selectIsLoadingSmartSearchCases,
  selectIsLoadingSmartSearchDeals,
  (isLoadingSmartSearches, isLoadingSmartSearchCases, isLoadingSmartSearchDeals: boolean): boolean =>
    isLoadingSmartSearches || isLoadingSmartSearchCases || isLoadingSmartSearchDeals,
);

export const selectPortfolioSmartSearches = createSelector(
  selectIsLoadingPortfolioSmartSearch,
  selectSmartSearches,
  selectSmartSearchCases,
  selectSmartSearchDealEntities,
  selectPropertyMortgageSelectItems,
  selectCanAccessSmartSearch,
  (
    isLoadingDashboardSmartSearchWithCaseAndDeals,
    smartSearches,
    smartSearchCases,
    smartSearchDealEntities,
    propertyMortgageSelectItems,
    canAccessSmartSearch,
  ): PortfolioSmartSearchModel[] => {
    if (isLoadingDashboardSmartSearchWithCaseAndDeals || !canAccessSmartSearch) return [];

    return smartSearches.map((smartSearch) =>
      portfolioSmartSearchAdapter(smartSearch, smartSearchDealEntities, smartSearchCases, propertyMortgageSelectItems),
    );
  },
);

export const selectPortfolioSmartSearch = (smartSearchId: string): MemoizedSelector<AppState, PortfolioSmartSearchModel> =>
  createSelector(
    selectPortfolioSmartSearches,
    (smartSearches): PortfolioSmartSearchModel => smartSearches.find((s) => s.id === smartSearchId),
  );
